import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import Footer from "../../components/Footer";

const TermsOfService = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="App">
            {/* Navigation */}
            <nav className="navbar">
                <div className="nav-container">
                    <div className="nav-logo">
                        <h2>AI Cards: Learn & Speak</h2>
                    </div>
                    <div className="nav-links">
                        <button onClick={() => navigate('/')} className="nav-link">Home</button>
                    </div>
                </div>
            </nav>

            {/* Terms of Service */}
            <section className="terms">
                <div className="container">
                    <h2>Terms of Service</h2>
                    <div className="terms-content">
                        <div className="terms-section">
                            <h3>1. Acceptance of Terms</h3>
                            <p>By downloading, installing, or using AI Cards: Learn & Speak ("the App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.</p>
                        </div>

                        <div className="terms-section">
                            <h3>2. Description of Service</h3>
                            <p>AI Language Cards is a language learning application that allows users to create personal word collections, share collections with the community, and access AI-generated word descriptions and examples.</p>
                        </div>

                        <div className="terms-section">
                            <h3>3. User Accounts and Content</h3>
                            <p>You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account. You retain ownership of content you create, but grant us a license to display and distribute your shared collections.</p>
                        </div>

                        <div className="terms-section">
                            <h3>4. AI Features</h3>
                            <p>The App uses artificial intelligence to generate word descriptions and examples. While we strive for accuracy, AI-generated content may contain errors and should not be considered as definitive language guidance.</p>
                        </div>

                        <div className="terms-section">
                            <h3>5. Community Guidelines</h3>
                            <p>When sharing collections with the community, you agree not to post content that is offensive, inappropriate, or violates any applicable laws. We reserve the right to remove content that violates these guidelines.</p>
                        </div>

                        <div className="terms-section">
                            <h3>6. Privacy</h3>
                            <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information.</p>
                        </div>

                        <div className="terms-section">
                            <h3>7. Intellectual Property</h3>
                            <p>The App and its original content, features, and functionality are owned by us and are protected by international copyright, trademark, and other intellectual property laws.</p>
                        </div>

                        <div className="terms-section">
                            <h3>8. Limitation of Liability</h3>
                            <p>In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the App.</p>
                        </div>

                        <div className="terms-section">
                            <h3>9. Changes to Terms</h3>
                            <p>We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms in the App.</p>
                        </div>

                        <div className="terms-section">
                            <h3>10. Contact Information</h3>
                            <p>If you have any questions about these Terms, please contact us through the App or via email.</p>
                            <p>aicardsfeedback@gmail.com</p>
                        </div>

                        <div className="terms-footer">
                            <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default TermsOfService;
